import { render, staticRenderFns } from "./attendance2.vue?vue&type=template&id=08e8be2b&scoped=true&"
import script from "./attendance2.vue?vue&type=script&lang=js&"
export * from "./attendance2.vue?vue&type=script&lang=js&"
import style0 from "./attendance2.vue?vue&type=style&index=0&id=08e8be2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e8be2b",
  null
  
)

export default component.exports